const data =
{
  id: 1,
  title: 'Choose the suitable form of adjective superlative to fill in the blank..',
  subTitle: 'Chọn dạng đúng của tính từ trong câu so sánh nhất',
  question: 'big',
  answers: [
    { id: 1, answer: 'bigger', isCorrect: false },
    { id: 2, answer: 'the biggest', isCorrect: true },
    { id: 3, answer: 'more big', isCorrect: false },

  ]
}

export default data;